export default "__VITE_ASSET__CE$PKd3c__"